module.exports = __webpack_public_path__ + "static/media/11.6e9c1456.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/11.png
 ** module id = 195
 ** module chunks = 0
 **/